/* eslint-disable */
import FuseAnimate from '@/@fuse/core/FuseAnimate';
import CustomButton from '@/app/customComponents/CustomButton/CustomButton';
import CustomDatePicker from '@shared/customComponents/CustomDatePicker/CustomDatePicker';
import { getMealReport, getRooms } from '@/app/services/reports/reports';
import * as Actions from '@/app/store/actions';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
	CircularProgress,
	FormControl,
	IconButton,
	InputLabel,
	MenuItem,
	Paper,
	Select,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Typography,
} from '@material-ui/core';
import { Close } from '@material-ui/icons';
import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useReactToPrint } from 'react-to-print';
import { useNavigate } from 'react-router-dom';
export default function Meal() {
	const dispatch = useDispatch();
	const user = useSelector(({ auth }) => auth.user);
	const navigate = useNavigate();
	const [rows, setRows] = useState({});
	const [isLoading, setIsLoading] = useState(false);
	const [hasMore, setHasMore] = useState(false);
	const [firstLoad, setFirstLoad] = useState(true);
	const [fetchingMore, setFetchingMore] = useState(false);
	const checkInReportRef = useRef(null);
	const [page, setPage] = useState(1);
	const [filters, setFilters] = useState({
		// school_id: user.school?.id || user.data?.school?.id,
		room_id: '',
		status: '',
		fromDate: '',
		toDate: '',
	});
	const [rooms, setRooms] = useState([]);
	const [roomPage, setRoomPage] = useState(1);
	const [searchQuery, setSearchQuery] = useState('');
	const [isLoadingExport, setIsLoadingExport] = useState(false);

	const handleSearch = (e) => {
		setSearchQuery(e.target.value);
	};

	const handlePrint = useReactToPrint({
		content: () => checkInReportRef.current,
	});

	useEffect(() => {
		let isMounted = true;
		getRooms('', roomPage)
			.then((res) => {
				if (!isMounted) return;
				setRooms([...rooms, ...res.data.data]);
				if (res.data.current_page < res.data.last_page) {
					setRoomPage(roomPage + 1);
				}
			})
			.catch((err) => {
				if (!isMounted) return;
				dispatch(
					Actions.showMessage({
						message: 'Failed to get rooms.',
						autoHideDuration: 1500,
						variant: 'error',
					})
				);
			});
		return () => {
			isMounted = false;
		};
	}, [roomPage, dispatch]);

	const ApplyFilters = () => {
		const allFilters = rooms?.map((room) => room?.id);
		setRows({});
		setIsLoading(true);
		setFirstLoad(false);
		const timeout = setTimeout(
			() => {
				getMealReport(filters, 0, allFilters)
					.then((res) => {
						setFirstLoad(false);
						setRows(res?.data);
						// if (res.data.last_page > res.data.current_page) {
						// 	setHasMore(true);
						// } else {
						// 	setHasMore(false);
						// }
						// setPage(res.data.current_page + 1);
						dispatch(
							Actions.showMessage({
								message: 'Report has been generated',
								variant: 'success',
							})
						);
						// setPage(res.data.current_page + 1);
					})
					.catch((err) => {
						dispatch(
							Actions.showMessage({
								message: 'Failed to fetch data, please refresh',
								variant: 'error',
							})
						);
					})
					.finally(() => {
						setIsLoading(false);
					});
			},
			firstLoad ? 0 : 1000
		);
		setPage(1);
		return () => {
			clearTimeout(timeout);
		};
	};

	const handleFilters = (ev) => {
		const { name, value } = ev.target;
		setFilters({ ...filters, [name]: value });
	};

	const handleExport = () => {
		const allFilters = rooms?.map((room) => room?.id);
		setIsLoadingExport(true);
		getMealReport(filters, 1, allFilters)
			.then((res) => {
				const blob = new Blob([res.data], {
					type: 'text/csv',
				});
				const link = document.createElement('a');
				link.setAttribute('target', '_blank');
				link.href = window.URL.createObjectURL(blob);
				link.setAttribute('download', `meal_report_${new Date().getTime()}.csv`);
				document.body.appendChild(link);
				link.click();
				// Clean up and remove the link
				link.parentNode.removeChild(link);
				setIsLoadingExport(false);
			})
			.catch((err) => {
				dispatch(
					Actions.showMessage({
						message: 'Failed to Export',
						variant: 'error',
					})
				);
				setIsLoadingExport(false);
			})
			.finally(() => {
				setIsLoadingExport(false);
			});
	};

	return (
		<FuseAnimate animation="transition.slideLeftIn" duration={600}>
			<div className="mx-auto allergy-cont">
				<div className="flex items-center flex-nowrap justify-between">
					<div className="reports-topDiv">
						<h1 className="my-16">
							{' '}
							<span className="">
								<IconButton
									onClick={() => {
										navigate('/reports');
									}}
								>
									<img alt="filter" className="" src="assets/images/arrow-long.png" width="24px" />
								</IconButton>
							</span>{' '}
							<span className="text-pd-xl self-end font-bold mr-28"> Meal</span>
						</h1>
						<p>
							The number of meals served, including a breakdown by students with each type of meal (free, reduced, or
							paid) and type of meal
						</p>
					</div>
					<div className="flex justify-between">
						<div className="flex">
							<div className="self-end btn-aller">
								<span>
									{!isLoadingExport ? (
										<CustomButton
											height="40px"
											marginRight="17px"
											onClick={handleExport}
											variant="primary"
											width="100px"
										>
											<span className="mr-4">
												<FontAwesomeIcon icon={faDownload} />
											</span>
											Export
										</CustomButton>
									) : (
										<div className="circle-bar">
											<CircularProgress size={35} />
										</div>
									)}
									{/* <CustomButton
										onClick={() => handlePrint()}
										variant="secondary"
										height="40px"
										width="100px"
									>
										<i className="fa fa-print" aria-hidden="true" /> Print
									</CustomButton> */}
									{/* <div className="help-btn cursor-pointer">
										<img src="assets/images/CENTER.png" />
										Help Center
									</div> */}
								</span>
							</div>
						</div>
					</div>
				</div>

				<div className="flex items-center flex-nowrap justify-between">
					<span className="text-pd-2xl self-end font-extrabold mr-28" />
					<div className="flex justify-between">
						<div className="flex">
							<div className="mx-8">
								<FormControl>
									<InputLabel id="room_id">Room</InputLabel>
									<Select
										endAdornment={
											filters.room_id ? (
												<IconButton className="mr-16" id="clear-room-filter" size="small">
													<Close
														fontSize="small"
														onClick={() => {
															setFilters({
																...filters,
																room_id: '',
															});
														}}
													/>
												</IconButton>
											) : (
												''
											)
										}
										id="room_id"
										label="Room"
										labelId="roomLabel"
										name="room_id"
										onChange={handleFilters}
										style={{ width: 150 }}
										value={filters.room_id}
									>
										<MenuItem value="All">All</MenuItem>
										{rooms?.length ? (
											rooms.map((room) => {
												return (
													<MenuItem id={room.id} key={room.id} value={room.id}>
														{room.name}
													</MenuItem>
												);
											})
										) : (
											<MenuItem disabled>Loading...</MenuItem>
										)}
									</Select>
								</FormControl>
							</div>
							<div className="mx-10 student-date-field" style={{ width: 150 }}>
								<CustomDatePicker
									id="date-from"
									label="Date From"
									maxDate={filters.toDate || new Date()}
									setValue={(date) => {
										setFilters({ ...filters, fromDate: date?.format('YYYY-MM-DD') || '' });
									}}
									value={filters.fromDate}
								/>
							</div>
							<div className="mr-20 ml-10 student-date-field" style={{ width: 150 }}>
								<CustomDatePicker
									id="date-to"
									label="Date To"
									maxDate={new Date()}
									minDate={filters.fromDate}
									setValue={(date) => {
										setFilters({ ...filters, toDate: date?.format('YYYY-MM-DD') || '' });
									}}
									value={filters.toDate}
								/>
							</div>
						</div>

						<div className="self-end">
							<span>
								<span className="mx-4">
									<CustomButton
										disabled={!filters.room_id && !filters.fromDate && !filters.toDate ? !filters.status : null}
										fontSize="15px"
										height="43"
										onClick={() => {
											ApplyFilters();
										}}
										variant="secondary"
										width="140px"
									>
										Apply
									</CustomButton>
								</span>
							</span>
						</div>
					</div>
				</div>

				{/* table  */}
				<TableContainer className="meal-table-cont" component={Paper} id="Scrollable-table">
					<div style={{ display: 'none' }}>
						<div className="p-32" ref={checkInReportRef}>
							<div className="flex flex-row justify-between">
								<div>
									<img alt="" src="assets/images/logos/logo.png" />
								</div>
								<div style={{ textAlign: 'right' }}>
									<Typography
										style={{
											maxWidth: '220px',
										}}
										variant="subtitle1"
									>
										<span style={{ display: 'block', marginBottom: '5px', writingMode: '' }}>
											{user?.data?.school?.address}
										</span>
									</Typography>
									<Typography variant="subtitle1">+ {user?.data?.phone}</Typography>
									<Typography variant="subtitle1">{user?.data?.email}</Typography>
								</div>
							</div>
							<div style={{ marginBottom: '20px' }}>
								<span>
									<strong>Date: </strong>
								</span>
								<span>{moment(new Date()).format('dddd, DD MMMM YYYY')}</span>
							</div>
							<div className="pdf-heading">
								<h1 className="font-extrabold">Meal Report</h1>
							</div>

							<Table className="student-table" stickyHeader style={{ width: '100%' }}>
								<TableHead>
									<TableRow>
										<TableCell className="bg-white studentTableHeader" style={{ width: '33%' }}>
											Student Type
										</TableCell>

										<TableCell className="bg-white studentTableHeader" style={{ width: '33%' }}>
											No of Students
										</TableCell>

										<TableCell className="bg-white studentTableHeader" style={{ width: '33%' }}>
											Percentage of Total
										</TableCell>
									</TableRow>
								</TableHead>
								<TableBody className="">
									{isLoading ? (
										<TableRow>
											<TableCell align="center" colSpan={8}>
												<CircularProgress size={35} />
											</TableCell>
										</TableRow>
									) : !rows && !firstLoad ? (
										<TableRow>
											<TableCell align="center" colSpan={8}>
												No record found
											</TableCell>
										</TableRow>
									) : (
										// rows?.map(row => (
										<>
											<TableRow>
												<TableCell
													className="bg-white truncate"
													style={{
														fontSize: '13px',
														maxWidth: '100px',
														fontWeight: 'bold',
														overflow: 'hidden',
														textOverflow: 'ellipsis',
														whiteSpace: 'nowrap',
													}}
												>
													<div className="report-meal ">Included</div>
												</TableCell>

												<TableCell
													className="bg-white truncate"
													style={{
														fontSize: '13px',
														maxWidth: '100px',
														fontWeight: 'bold',
														overflow: 'hidden',
														textOverflow: 'ellipsis',
														whiteSpace: 'nowrap',
													}}
												>
													<div className="report-meal ">{rows?.countIncluded}</div>
												</TableCell>
												<TableCell
													className="bg-white truncate"
													style={{
														fontSize: '13px',
														maxWidth: '100px',
														fontWeight: 'bold',
														overflow: 'hidden',
														textOverflow: 'ellipsis',
														whiteSpace: 'nowrap',
													}}
												>
													<div className="report-meal ">
														{rows?.includedPercentage ? `${rows?.includedPercentage?.toFixed(2)}%` : '0%'}
													</div>
												</TableCell>
											</TableRow>
											<TableRow>
												<TableCell
													className="bg-white truncate"
													style={{
														fontSize: '13px',
														maxWidth: '100px',
														fontWeight: 'bold',
														overflow: 'hidden',
														textOverflow: 'ellipsis',
														whiteSpace: 'nowrap',
													}}
												>
													<div className="report-meal ">Brought From Home</div>
												</TableCell>

												<TableCell
													className="bg-white truncate"
													style={{
														fontSize: '13px',
														maxWidth: '100px',
														fontWeight: 'bold',
														overflow: 'hidden',
														textOverflow: 'ellipsis',
														whiteSpace: 'nowrap',
													}}
												>
													<div className="report-meal ">{rows?.countBroughtFromHome}</div>
												</TableCell>
												<TableCell
													className="bg-white truncate"
													style={{
														fontSize: '13px',
														maxWidth: '100px',
														fontWeight: 'bold',
														overflow: 'hidden',
														textOverflow: 'ellipsis',
														whiteSpace: 'nowrap',
													}}
												>
													<div className="report-meal ">
														{rows?.includedPercentage ? `${rows?.broughtFromHomePercentage?.toFixed(2)}%` : '0%'}
													</div>
												</TableCell>
											</TableRow>
											<TableRow>
												<TableCell
													className="bg-white truncate"
													style={{
														fontSize: '13px',
														maxWidth: '100px',
														fontWeight: 'bold',
														overflow: 'hidden',
														textOverflow: 'ellipsis',
														whiteSpace: 'nowrap',
													}}
												>
													<div className="report-meal studentTableHeader">Total</div>
												</TableCell>

												<TableCell
													className="bg-white truncate"
													style={{
														fontSize: '13px',
														maxWidth: '100px',
														fontWeight: 'bold',
														overflow: 'hidden',
														textOverflow: 'ellipsis',
														whiteSpace: 'nowrap',
													}}
												>
													<div className="report-meal studentTableHeader">{rows?.total}</div>
												</TableCell>
												<TableCell
													className="bg-white truncate"
													style={{
														fontSize: '13px',
														maxWidth: '100px',
														fontWeight: 'bold',
														overflow: 'hidden',
														textOverflow: 'ellipsis',
														whiteSpace: 'nowrap',
													}}
												>
													<div className="report-meal studentTableHeader">{rows?.total ? `100%` : '0%'}</div>
												</TableCell>
											</TableRow>
										</>
										// ))
									)}
									{/* {fetchingMore ? (
										<TableRow>
											<TableCell align="center" colSpan={8}>
												<CircularProgress size={35} />
											</TableCell>
										</TableRow>
									) : (
										<></>
									)} */}
								</TableBody>
							</Table>
						</div>
					</div>
					<Table className="student-table" stickyHeader style={{ width: '100%' }}>
						<TableHead>
							<TableRow>
								<TableCell className="bg-white studentTableHeader" style={{ width: '33%' }}>
									Student Type
								</TableCell>

								<TableCell className="bg-white studentTableHeader" style={{ width: '33%' }}>
									No of Students
								</TableCell>

								<TableCell className="bg-white studentTableHeader" style={{ width: '33%' }}>
									Percentage of Total
								</TableCell>
							</TableRow>
						</TableHead>
						<TableBody className="">
							{firstLoad ? (
								<TableRow>
									<TableCell align="center" colSpan={8}>
										Generate your report
									</TableCell>
								</TableRow>
							) : isLoading ? (
								<TableRow>
									<TableCell align="center" colSpan={8}>
										<CircularProgress size={35} />
									</TableCell>
								</TableRow>
							) : !rows && !firstLoad ? (
								<TableRow>
									<TableCell align="center" colSpan={8}>
										No record found
									</TableCell>
								</TableRow>
							) : (
								// rows?.map(row => (
								<>
									<TableRow>
										<TableCell
											className="bg-white truncate"
											style={{
												fontSize: '13px',
												maxWidth: '100px',
												fontWeight: 'bold',
												overflow: 'hidden',
												textOverflow: 'ellipsis',
												whiteSpace: 'nowrap',
											}}
										>
											<div className="report-meal ">Included</div>
										</TableCell>

										<TableCell
											className="bg-white truncate"
											style={{
												fontSize: '13px',
												maxWidth: '100px',
												fontWeight: 'bold',
												overflow: 'hidden',
												textOverflow: 'ellipsis',
												whiteSpace: 'nowrap',
											}}
										>
											<div className="report-meal ">{rows?.countIncluded}</div>
										</TableCell>
										<TableCell
											className="bg-white truncate"
											style={{
												fontSize: '13px',
												maxWidth: '100px',
												fontWeight: 'bold',
												overflow: 'hidden',
												textOverflow: 'ellipsis',
												whiteSpace: 'nowrap',
											}}
										>
											<div className="report-meal ">
												{rows?.includedPercentage ? `${rows?.includedPercentage?.toFixed(2)}%` : '0%'}
											</div>
										</TableCell>
									</TableRow>
									<TableRow>
										<TableCell
											className="bg-white truncate"
											style={{
												fontSize: '13px',
												maxWidth: '100px',
												fontWeight: 'bold',
												overflow: 'hidden',
												textOverflow: 'ellipsis',
												whiteSpace: 'nowrap',
											}}
										>
											<div className="report-meal ">Brought From Home</div>
										</TableCell>

										<TableCell
											className="bg-white truncate"
											style={{
												fontSize: '13px',
												maxWidth: '100px',
												fontWeight: 'bold',
												overflow: 'hidden',
												textOverflow: 'ellipsis',
												whiteSpace: 'nowrap',
											}}
										>
											<div className="report-meal ">{rows?.countBroughtFromHome}</div>
										</TableCell>
										<TableCell
											className="bg-white truncate"
											style={{
												fontSize: '13px',
												maxWidth: '100px',
												fontWeight: 'bold',
												overflow: 'hidden',
												textOverflow: 'ellipsis',
												whiteSpace: 'nowrap',
											}}
										>
											<div className="report-meal ">
												{rows?.broughtFromHomePercentage ? `${rows?.broughtFromHomePercentage?.toFixed(2)}%` : '0%'}
											</div>
										</TableCell>
									</TableRow>
									<TableRow>
										<TableCell
											className="bg-white truncate"
											style={{
												fontSize: '13px',
												maxWidth: '100px',
												fontWeight: 'bold',
												overflow: 'hidden',
												textOverflow: 'ellipsis',
												whiteSpace: 'nowrap',
											}}
										>
											<div className="report-meal studentTableHeader">Total</div>
										</TableCell>

										<TableCell
											className="bg-white truncate"
											style={{
												fontSize: '13px',
												maxWidth: '100px',
												fontWeight: 'bold',
												overflow: 'hidden',
												textOverflow: 'ellipsis',
												whiteSpace: 'nowrap',
											}}
										>
											<div className="report-meal studentTableHeader">{rows?.total}</div>
										</TableCell>
										<TableCell
											className="bg-white truncate"
											style={{
												fontSize: '13px',
												maxWidth: '100px',
												fontWeight: 'bold',
												overflow: 'hidden',
												textOverflow: 'ellipsis',
												whiteSpace: 'nowrap',
											}}
										>
											<div className="report-meal studentTableHeader">{rows?.total ? `100%` : '0%'}</div>
										</TableCell>
									</TableRow>
								</>
								// ))
							)}
							{/* {fetchingMore ? (
								<TableRow>
									<TableCell align="center" colSpan={8}>
										<CircularProgress size={35} />
									</TableCell>
								</TableRow>
							) : (
								<></>
							)} */}
						</TableBody>
					</Table>
				</TableContainer>
				{/* <InfiniteScroll
					dataLength={rows?.length}
					next={handleLoadMore}
					hasMore={hasMore}
					scrollableTarget="Scrollable-table"
				/> */}
			</div>
		</FuseAnimate>
	);
}
